export type AppEnvironment = "dev" | "test" | "prod";

const ENVIRONMENT_LABELS: Record<AppEnvironment, string> = {
  dev: "DEV",
  test: "TEST",
  prod: "PRODUCTION",
};

const rawEnvironment = (process.env.REACT_APP_ENVIRONMENT || "dev").toLowerCase();

export const APP_ENVIRONMENT: AppEnvironment =
  rawEnvironment === "test" || rawEnvironment === "prod" ? rawEnvironment : "dev";

export const ENVIRONMENT_LABEL = ENVIRONMENT_LABELS[APP_ENVIRONMENT];
